'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

import { ANALYTICS_EVENTS } from '@/constants';

import { MobileBadge } from './mobile-badge';

export enum QRCodeSizes {
  SMALL = 'sm',
  LARGE = 'lg',
}

type AppBadgesProps = {
  size?: QRCodeSizes;
};

export const AppBadges = ({ size = QRCodeSizes.LARGE }: AppBadgesProps) => {
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [isUndetermined, setIsUndetermined] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent || '';
    setIsAndroid(Boolean(userAgent.match(/Android/i)));
    setIsIos(Boolean(userAgent.match(/iPhone|iPad|iPod/i)));
    setIsUndetermined(Boolean(!isAndroid && !isIos));
    setIsSignUp(Boolean(window.location.href.includes('sign-up/confirmation')));
  }, [isAndroid, isIos, isSignUp, isUndetermined]);

  return (
    <>
      <div className="hidden items-start gap-b lg:flex">
        <Image
          src="/qr-apple.png"
          alt="App store"
          quality={100}
          width={size === QRCodeSizes.LARGE ? 100 : 64}
          height={size === QRCodeSizes.LARGE ? 100 : 64}
          data-testid="apple-qr"
        />
        <Image
          src="/qr-android.png"
          alt="Play store"
          quality={100}
          width={size === QRCodeSizes.LARGE ? 100 : 64}
          height={size === QRCodeSizes.LARGE ? 100 : 64}
          data-testid="google-qr"
        />
      </div>
      <div className="flex items-start gap-b lg:hidden">
        {isIos || isUndetermined ? (
          <MobileBadge
            href={process.env.NEXT_PUBLIC_APP_STORE_APP_URL}
            src="/app-store-badge.png"
            alt="App store"
            testid="apple-badge"
            width={144}
            height={48}
            analyticEventName={
              isSignUp ? ANALYTICS_EVENTS.signup.apps.ios : undefined
            }
          />
        ) : null}
        {isAndroid || isUndetermined ? (
          <MobileBadge
            href={process.env.NEXT_PUBLIC_PLAY_STORE_APP_URL}
            src="/google-play-badge.png"
            alt="Play store"
            testid="google-badge"
            width={160}
            height={48}
            analyticEventName={
              isSignUp ? ANALYTICS_EVENTS.signup.apps.android : undefined
            }
          />
        ) : null}
      </div>
    </>
  );
};
